import "./style.css";
import layout from "./layout.html";
import CustomImage from "@blocks/Image";

export default class Block10 {
  static selector = ".block-10";

  constructor(block, attrs) {
    this.block = block;

    this.block.innerHTML = layout;

    this.imageTemplate = this.block.querySelector("#block-10__image-template");

    this.attributes = attrs;
  }

  setupItem = async (element) => {
    return new Promise(async (resolve) => {
      const imageNode =
        this.imageTemplate.content.firstElementChild.cloneNode(true);
      if (imageNode) {
        await new CustomImage(imageNode, element).onReady();

        resolve(imageNode);
      } else {
        reject(false);
      }
    });
  };

  setup = async () => {
    return new Promise(async (resolve) => {
      this.attributes.forEach(async (element) => {
        const imageNode = await this.setupItem(element);
        if (imageNode) {
          this.block.appendChild(imageNode);
        }
      });
      resolve();
    });
  };

  onReady = async () => {
    return new Promise(async (resolve) => {
      this.mounted = true;

      await this.setup();

      resolve();
    });
  };
}
